import React from "react";
import WalletAnalyticsBoard from "./WalletAnalyticsBoard";

/** Full wallet analytics — lives on Transactions → Analytics only (not Workspace). */
const TransactionsAnalyticsPanel = ({ transactions = [], loading = false }) => (
  <div className="tx-analytics-panel">
    <WalletAnalyticsBoard
      transactions={transactions}
      loading={loading}
      chartHeight={260}
      className="tx-analytics-board"
    />
  </div>
);

export default TransactionsAnalyticsPanel;
